module.exports = __webpack_public_path__ + "img/architecture-style-icon_2.b78a3223.png";